import styles from './bronnoysund-admin.module.scss';
import { Col, Row } from 'reactstrap';
import { useGetRequestNewHook, useMakeRequestHook, useTableConfigHook } from '../requestUtils';
import WebkuaTable from '../webkua-table/webkua-table';
import { ValueFormatterParams } from 'ag-grid-community';
import PageTitle from '../page-title/page-title';
import { Container, CreateHeaders, booleanHeader, textHeader, HeaderSizeEnum, PrimaryButton, Box } from '@frontend-workspace/react-shared-lib';
import BronnoysundDetailsExpand from '../bronnoysund-details-expand/bronnoysund-details-expand';
import BronnoysundAdminSkeleton from './bronnoysund-admin-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface BronnoysundAdminProps { }

export function BronnoysundAdmin(props: BronnoysundAdminProps) {
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const { data } = useGetRequestNewHook("admin/BronnoysundCompanies", null);
  const tableConfig = useTableConfigHook("bronnoysund");

  const syncRenderer = (params: ValueFormatterParams) => {
    const handleClick = () => {
      makeRequest(`admin/action/syncWithBRonnoysund`, 'PUT', {
        orgNr: params.data.orgNr,
        bregPostAddress: params.data.bsPostAddress,
        bregVisitingAddress: params.data.bsAddress,
        bregCompanyName: params.data.bsName,
        bregIsBankrupt: params.data.isBankruptInBS,
        bregvisitingZipCode: params.data.bsZipCode,
        bregPostZipCode: params.data.bsPostZipCode,
      });
    }
    return (
      <PrimaryButton variant='outlined' size='small' onClick={handleClick}>
        {t("bronnoysundAdmin.syncWithBronnoysund")}
      </PrimaryButton>
    )
  }

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title='Brønnøysund' subtitle='' />
            {!data ? <BronnoysundAdminSkeleton /> :
              <WebkuaTable
                data={data}
                headers={CreateHeaders([
                  textHeader("bsName", t("bronnoysundAdmin.bsName"), HeaderSizeEnum.EXTRA_LARGE, {
                    renderer: 'agGroupCellRenderer',
                    cellStyle: { fontSize: '0.875rem', fontWeight: '600' }
                  }),
                  textHeader("bsAddress", t("bronnoysundAdmin.bsAddress"), HeaderSizeEnum.EXTRA_LARGE),
                  textHeader("bsZip", t("bronnoysundAdmin.bsZip"), HeaderSizeEnum.LARGE),
                  textHeader("bsPostZip", t("bronnoysundAdmin.bsPostZip"), HeaderSizeEnum.EXTRA_LARGE),
                  textHeader("bsCity", t("bronnoysundAdmin.bsCity"), HeaderSizeEnum.EXTRA_LARGE),
                  textHeader("bsPostCity", t("bronnoysundAdmin.bsPostCity"), HeaderSizeEnum.EXTRA_LARGE),
                  textHeader("bsPostAddress", t("bronnoysundAdmin.bsPostAddress"), HeaderSizeEnum.EXTRA_LARGE),
                  textHeader("activeContracts", t("bronnoysundAdmin.activeContracts"), HeaderSizeEnum.EXTRA_LARGE, {
                    cellStyle: { justifyContent: 'right' },
                    headerClass: "ag-right-aligned-header"
                  }),
                  booleanHeader("isBankruptInBS", t("bronnoysundAdmin.bankruptInBS")),
                  booleanHeader("isLiquidating", t("bronnoysundAdmin.liquidating")),
                  booleanHeader("hasDifferentAddress", t("bronnoysundAdmin.differentAddress")),
                  booleanHeader("hasDifferentPostAddress", t("bronnoysundAdmin.differentPostAddress")),
                  booleanHeader("hasDifferentName", t("bronnoysundAdmin.differentName")),
                  booleanHeader("hasDifferences", t("bronnoysundAdmin.different")),
                  textHeader("", "", HeaderSizeEnum.EXTRA_LARGE, {
                    renderer: syncRenderer,
                    cellStyle: { justifyContent: 'right' },
                    headerClass: "ag-right-aligned-header"
                  })
                ])}
                tableConfig={tableConfig}
                expandComponent={BronnoysundDetailsExpand}
                pageSize={15}
              />}
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default BronnoysundAdmin;

